const PGAdapter = require('./../../common/pg-adapter')
const {
  SHARED_ROUTE_COLUMNS,
  SHARED_VIRTUAL_COLUMNS,
  SHARED_GET_RELATED,
  SHARED_COLUMN_PREPARERS
} = require('./route-pg-adapter-shared')

const ROUTE_TABLE_NAME = 'avocado.data_route'

class RoutePGDataAdapter extends PGAdapter {
  constructor (pgConnection, user, logger) {
    const columnPreparers = { ...SHARED_COLUMN_PREPARERS }

    super(
      pgConnection,
      ROUTE_TABLE_NAME,
      user,
      [...SHARED_ROUTE_COLUMNS],
      undefined,
      columnPreparers,
      logger,
      {
        getRelated: SHARED_GET_RELATED,
        virtualColumns: SHARED_VIRTUAL_COLUMNS,
        securedByOrganisationId: true
      }
    )
  }
}

module.exports = RoutePGDataAdapter
